import { c as _c } from "react-compiler-runtime";
import { useContext, useMemo } from 'react';
import { FullVirtualizationContext } from '../virtualization/VirtualizationContext';
export const getScrollMode = (pageable, pageSize) => {
  if (!pageable) return 'infinite-scroll';
  return `paginated-${pageSize !== null && pageSize !== void 0 ? pageSize : 'unknown'}`;
};
export const useMetricsDimensions = (pageable, pageSize) => {
  const $ = _c(6);
  const enableFullVirtualization = useContext(FullVirtualizationContext);
  const t0 = enableFullVirtualization ? "full" : "legacy";
  let t1;
  if ($[0] !== pageSize || $[1] !== pageable) {
    t1 = getScrollMode(pageable, pageSize);
    $[0] = pageSize;
    $[1] = pageable;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t0 || $[4] !== t1) {
    t2 = {
      virtualization_mode: t0,
      scroll_mode: t1
    };
    $[3] = t0;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};